<template>
  <div class="w-100 bg-grey p-5">
    <h1 class="col-12 text-dark openSans-bold text-center w-100 mb-5">Focus</h1>
    <div id="focusGroup" class="d-flex justify-content-center">
        <focus-preview v-for="(element, idx) in focusToInsert" :key="idx" :focus="element"></focus-preview>
    </div>
  </div>
</template>

<script>
import DataApi from 'fm-data-api'
import Vue from 'vue'

export default {
  name: 'InfosCGC',
  data () {
    return {
      focusToInsert: []
    }
  },
  components: {
    FocusPreview: () => import('../../components/FocusPreview.vue')
  },
  methods: {
    async getFocus (societe, rubrique) {
      const options = {
        apiUrl: this.$apiUrl,
        databaseName: this.$databaseName,
        token: await this.$getMainToken()
      }
      this.dataApi = new DataApi(options)
      this.dataApi.findRecords('W_Focus', { 'foc_RBQ__Rubrique::d_nomRubrique': rubrique, 'foc_rbq_SOC__Societe::d_nomSociete': societe }, '', '', '4')
        .then((focusList) => {
          this.insertFocus(focusList)
        })
    },
    insertFocus (focusL) {
      const focusList = (focusL === undefined) ? [] : focusL
      if (focusList.length > 0) {
        this.biensEmpty = false
        const focusToInsert = {}
        focusList.forEach(function (value, index) {
          const dataToInsert = Vue.removeLayout(value.fieldData)
          dataToInsert.recordId = value.recordId
          focusToInsert[index] = dataToInsert
        }, this)
        this.focusToInsert = focusToInsert
      } else {
        this.focusToInsert = {}
      }
    }
  },
  async beforeMount () {
    await this.getFocus('CG Courtage', 'Info')
  }
}
</script>
<style lang="scss" scoped>
.elementFocus {
  height: 100%;
  width: 100%;
  border: solid 1px black;
  img {
    width: 100% !important;
    height: 15rem !important;
  }
  .readMore.CG:hover {
    u {
      color: var(--primary) !important;
    }
  }
  .readMore.Tolus:hover {
    u {
      color: var(--secondary) !important;
    }
  }
  .content {
    height: 6rem !important;
    overflow: hidden;
  }
}
.focusTitle {
  p {
    padding-right: 7rem !important;
  }
}
</style>
